import { render, staticRenderFns } from "./ServersTable.vue?vue&type=template&id=cd06ece0&"
import script from "./ServersTable.vue?vue&type=script&lang=js&"
export * from "./ServersTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports